import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  ${mq({
    display: ['block', 'block', 'grid'],
    gridTemplateColumns: ['100px', '100px', 'auto 60px'],
  })}
`
